import { apiConfig } from '@/services/api-config';

export default async function (resp: any) {
  return apiConfig
    .post('api/Ticket/get-tickets-by-cdterritory', resp)
    .then((response) => response.data)
    .catch(() => []);
}
